import { SVGProps } from 'react';

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.93945 6.70697L13.2325 12L7.93945 17.293L9.35345 18.707L16.0605 12L9.35345 5.29297L7.93945 6.70697Z"
      fill="currentColor"
    />
  </svg>
);
